export const colors = {
    yellow: "#e2e738",
    blue: "#0005df",
    green: "#29d13d",
    pink: "#ff00ff",
    orange: "#ff5100",
}
